import { css } from '@emotion/react'
import Link from 'next/link'
import { Button } from '../components/curriculum/Button'
import {
  type Principles,
  principles,
} from '../components/curriculum/Principles'
import { Divider } from '../components/divider/Divider'
import { Explanation } from '../components/explanation/Explanation'
import { Layout } from '../components/Layout'

export const numberOfGuides = 12
export const principlesToUse = Object.keys(principles)

const Curriculum = () => {
  return (
    <Layout>
      <div className="w90 mw1000 center fcs">
        <h1 className="tcenter huge mt20">Curriculum 🎓</h1>
        <Explanation color="blue" className="wauto mb20">
          <div className="tcenter center">
            <strong>Instructions: </strong>Start with the weight loss{' '}
            <Link href="/weight-loss">guide</Link> or{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://youtu.be/AxMCnDvgY-c"
            >
              video
            </a>
            .
          </div>
        </Explanation>
        <div
          className="frc wrap w100"
          css={css`
            a {
              text-decoration: none;
              flex: 1;
            }
          `}
        >
          {Object.keys(principles)
            .slice(-1)
            .map((p) => (
              <Button key={p} principle={p as Principles} />
            ))}
        </div>
        <Divider className="mt-5" />
        <div
          className="frc wrap w100"
          css={css`
            a {
              text-decoration: none;
              flex: 1;
            }
          `}
        >
          {Object.keys(principles)
            .filter((p) => !['Weight loss'].includes(p))
            .map((p) => (
              <Button key={p} principle={p as Principles} />
            ))}
        </div>
      </div>
    </Layout>
  )
}

export default Curriculum
